import React from 'react';
import appleStoreIcon from "../../../../../assets/icon-apple-store.png";
import googlePlayIcon from "../../../../../assets/icon-google-play.png";
import { StoreButtonsContainer, StoreLink, StoreImage } from './LandingStoreButtons.styles';

export const LandingStoreButtons: React.FC = () => {
  return (
      <StoreButtonsContainer className="landing--store-buttons flex w-100 xs-mt-4 sm-mt-3 mt-10">
        <StoreLink
          href="https://apps.apple.com/us/app/flipped-on-dogs-training-game/id6738010112"
          target="_blank"
          rel="noopener noreferrer"
        >
          <StoreImage
            src={appleStoreIcon}
            alt="Download on the App Store"
            className="w-100"
          />
        </StoreLink>
        <StoreLink
          href="https://play.google.com/store/apps/details?id=com.talkdog.flippedondogs"
          target="_blank"
          rel="noopener noreferrer"
        >
          <StoreImage
            src={googlePlayIcon}
            alt="Get it on Google Play"
            className="w-100"
          />
        </StoreLink>
      </StoreButtonsContainer>
  );
};